module.exports = __webpack_public_path__ + "img/0Q3B5795_Black.a3f0e9fd.jpg";